import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide12NextSteps({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-86">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-87">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-88">
          Closing Recommendation
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08] max-w-5xl" data-id="element-89">
          Start with a{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-90">
            focused Wave 1.
          </span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-12 gap-8 min-h-0" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="col-span-7 bg-white rounded-3xl p-10 border border-black/5 shadow-xl flex flex-col justify-center relative overflow-hidden" data-id="element-92">
          <div className="absolute top-0 left-0 w-full h-2 bg-[var(--brand-green)]" data-id="element-93" />

          <h3 className="text-2xl font-bold text-[var(--fg)] mb-6" data-id="element-94">
            Snakkify the Anzupgo website experience, create four short teaser
            masters, and build two deeper trailer masters.
          </h3>

          <p className="text-[var(--muted)] text-lg font-medium leading-relaxed mb-8" data-id="element-95">
            This gives LEO an improved website engagement layer and a reusable
            campaign library that can immediately power outbound activation.
            Wave 1 is designed to prove the model, generate engagement insight,
            and identify which messages should be scaled in Wave 2.
          </p>

          <div className="flex items-center gap-4 text-[var(--brand-green)] font-bold uppercase tracking-wider text-sm flex-wrap" data-id="element-96">
            <span data-id="element-97">Content Audit</span> <ArrowRight className="w-4 h-4" data-id="element-98" />
            <span data-id="element-99">Storyboard</span> <ArrowRight className="w-4 h-4" data-id="element-100" />
            <span data-id="element-101">Production</span> <ArrowRight className="w-4 h-4" data-id="element-102" />
            <span data-id="element-103">Launch</span> <ArrowRight className="w-4 h-4" data-id="element-104" />
            <span data-id="element-105">Reporting</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="col-span-5 bg-white rounded-3xl p-6 border border-black/5 shadow-lg flex flex-col items-center justify-center relative overflow-hidden" data-id="element-106">
          <p className="text-[var(--brand-green)] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-107">
            What a wave looks like
          </p>
          <div className="w-full flex-1 relative bg-[var(--surface)] rounded-xl border border-black/5 p-4" data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/wWheb1ahK2YTaF9M2yD9Va/Screenshot_2026-06-29_at_11.23.35.png" alt="Campaign Flow Diagram" className="w-full h-full object-contain" data-id="element-109" />
          </div>
        </motion.div>
      </div>
    </div>;
}